const FOOTER_NAV: ReadonlyArray<{
  heading: string;
  links: ReadonlyArray<{ label: string; href: string; external: boolean }>;
}> = [
  {
    heading: "Produkt",
    links: [
      { label: "Funktionen", href: "/#funktionen", external: false },
      { label: "So geht's", href: "/#so-gehts", external: false },
      { label: "Sicherheit & DSGVO", href: "/#sicherheit", external: false },
      { label: "Ratgeber", href: "/ratgeber", external: false },
      { label: "Über uns", href: "/#ueber-uns", external: false },
    ],
  },
  {
    heading: "Rechtliches",
    links: [
      { label: "Impressum", href: "/impressum", external: false },
      { label: "Datenschutz", href: "/datenschutz", external: false },
      { label: "AGB", href: "/agb", external: false },
    ],
  },
];

export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-surface-variant bg-surface-container-lowest">
      <div className="container-welope py-16 lg:py-20">
        <div className="grid grid-cols-1 gap-lg lg:grid-cols-12 lg:gap-xl">
          {/* Brand-Spalte */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary shadow-bloom-sm">
                <BrandMark className="h-6 w-6 text-on-primary" />
              </span>
              <span className="font-headline text-headline-md leading-none text-primary">
                welope
              </span>
            </div>
            <p className="mt-4 max-w-sm font-body text-body-md text-on-surface-variant">
              Das soziale Netzwerk für Haustiere — gemacht mit Liebe in Deutschland. Self-hosted,
              DSGVO-konform.
            </p>
          </div>

          {/* Navigations-Spalten */}
          {FOOTER_NAV.map((column) => (
            <nav
              key={column.heading}
              aria-label={column.heading}
              className="lg:col-span-3"
            >
              <h3 className="font-headline text-label-md uppercase tracking-[0.12em] text-primary">
                {column.heading}
              </h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="font-body text-body-md text-on-surface-variant transition-colors hover:text-primary"
                      rel={link.external ? "noopener noreferrer" : undefined}
                      target={link.external ? "_blank" : undefined}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* Kontakt-Spalte */}
          <div className="lg:col-span-2">
            <h3 className="font-headline text-label-md uppercase tracking-[0.12em] text-primary">
              Kontakt
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href="mailto:info@solutioit.de"
                  className="font-body text-body-md text-on-surface-variant transition-colors hover:text-primary"
                >
                  info@solutioit.de
                </a>
              </li>
              <li className="font-body text-body-md text-on-surface-variant">
                Jamie Hennemann
                <br />
                Hauptstraße 5a
                <br />
                56479 Liebenscheid
                <br />
                Deutschland
              </li>
            </ul>
          </div>
        </div>

        {/* Trust-Strip */}
        <div className="mt-12 flex flex-col gap-4 border-t border-surface-variant pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-label-sm text-on-surface-variant">
            © {new Date().getFullYear()} Jamie Hennemann — Alle Rechte vorbehalten. Erstellt von{" "}
            <a
              href="https://solutioit.de"
              target="_blank"
              rel="noopener noreferrer"
              className="underline transition-colors hover:text-primary"
            >
              solutioit.de
            </a>
          </p>
          <p className="flex items-center gap-2 font-body text-label-sm text-on-surface-variant">
            <span aria-hidden className="font-body text-body-sm">DE</span>
            <span>
              Self-hosted in Liebenscheid, Rheinland-Pfalz
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}

function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      role="img"
    >
      <ellipse cx="12" cy="15" rx="4" ry="3" />
      <circle cx="7" cy="9" r="2" />
      <circle cx="17" cy="9" r="2" />
      <circle cx="4.5" cy="13" r="1.6" />
      <circle cx="19.5" cy="13" r="1.6" />
    </svg>
  );
}
